import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledFormsTemplatesListItemItemName = styled(StyledFlex)`
   height: 100%;
   width: 100%;
`;
